export default "__VITE_ASSET__bf03e2e6__"